<template>
  <div>
    <table v-if="departments.length > 0" style="width:500px;">
      <tr>
        <th v-for="key in Object.keys(departments[0])" :key="key">
          {{key}}
        </th>
      </tr>
      <tr v-for="(row, index) in departments" :key="index">
        <td v-for="key in Object.keys(departments[index])" :key="key">
          {{row[key]}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'CategoriesCRUD',
  props: ['location'],
  data () { return { 
    departments: [],
    departmentsObject: {},
    
    }
  },
  created: function(){
    this.loadData();
  },
  methods : {
    loadData: function(){
      this.departments = [];
      this.departmentsObject = {};
      const options = {attributes:['Dept_ID', 'Description']}
      // options.include = ['category']
      // options.include = [{ "all": true, "nested": true }]
      options.include = [{ model: 'categories', attributes: ['Description']}]

      i_axios.get(`/api/${this.location}/departments`, {params: options}).then((r)=>{
        r.data.forEach(r=> {r.Category = r.category.Description; delete r.category});
        this.departments = r.data
        r.data.forEach(row=>this.departmentsObject[row.Dept_ID] = row);
        

        this.$emit('input', this.departmentsObject)
      });
    },
  }, 
}
</script>
